export default function FullUWCoverageLengths() {
  return [
    { label: '5 Year Term', value: '5' },
    { label: '10 Year Term', value: '10' },
    { label: '15 Year Term', value: '15' },
    { label: '20 Year Term', value: '20' },
    { label: '25 Year Term', value: '25' },
    { label: '30 Year Term', value: '30' },
  ];
}
